<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :search.sync="search"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
            type="text"
            v-if="permissionList.editBtn"
            @click="toEdit(scope.row)">编 辑
        </el-button>
        <el-button
            type="text"
            v-if="permissionList.delBtn"
            @click="toDel(scope.row)">删 除
        </el-button>
      </template>

      <template slot="fileAttachForm" slot-scope="scope">
        <vUpload
          :max="5242880"
          :limit="10"
          :fileList.sync="form.fileAttach"
          :types="fileTypes"
        ></vUpload>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getPage, save, update, getDetail, remove } from '@/api/businessmanage/business-manage';
import { mapGetters } from 'vuex';
import vUpload from "@/views/components/v-upload";

export default {
  components: {
    vUpload
  },
  data() {
    return {
      fileTypes:[
        'jpg', 'png'
      ],
      disabled:false,
      form: {
        fileAttach:[],
      },
      // 搜索确认的数据
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 搜索表单中的数据，没点击搜索之前的数据
      search: {
        businessName: '',
      },
      selectionList: [],
      option: {
        menuWidth:140,
        height: 'auto',
        calcHeight: 32,
        dialogWidth: 1000,
        tip: false,
        searchShow: true,
        searchMenuSpan: 18,
        border: true,
        index: true,
        editBtn: false,
        delBtn: false,
        // emptyBtn: false,
        addTitle: '新增',
        addBtnIcon: '',
        editTitle: '编辑',
        // viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 150,
        searchLabelWidth: 120,
        column: [
          {
            label: '商业项目名称',
            prop: 'businessName',
            span: 24,
            search: true,
            maxlength: 30,
            showWordLimit:true,
            searchClearable: false,
            rules: [
              {
                required: true,
                message: '请输入商业项目名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '管理面积(m²)',
            prop: 'manageArea',
            width: 120,
            span: 12,
            maxlength: 12,
            showWordLimit:true,
            rules: [
              {
                required: true,
                message: '请输入管理面积',
                trigger: 'blur',
              },
              {
                pattern: /^(\d{1,9}|\d{1,9}\.\d{1,2})$/,
                message: '请输入0~999999999.99之间的数字',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '经营收入(万元)',
            prop: 'operateIncome',
            showWordLimit:true,
            span: 12,
            maxlength: 12,
            rules: [
              {
                required: true,
                message: '请输入经营收入',
                trigger: 'change',
              },
              {
                pattern: /^(\d{1,9}|\d{1,9}\.\d{1,2})$/,
                message: '请输入0~999999999.99之间的数字',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '排序',
            prop: 'sort',
            width: 120,
            span: 12,
            maxlength: 3,
            showWordLimit:true,
            rules: [
              {
                required: true,
                message: '请输入排序',
                trigger: 'blur',
              },
              {
                pattern: /^\d+$/,
                message: '请输入数字',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '项目简介',
            prop: 'description',
            width: 120,
            hide:true,
            span: 24,
            maxlength: 200,
            type: 'textarea',
            minRows: 2,
            maxRows: 5,
            showWordLimit:true,
            rules: [
              {
                required: true,
                message: '请输入项目简介',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '附件上传',
            prop: 'fileAttach',
            formslot: true,
            hide: true,
            span: 24,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.business_manage_add, false),
        delBtn: this.vaildData(this.permission.business_manage_del, false),
        editBtn: this.vaildData(this.permission.business_manage_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },

  },
  async created() {
    this.onLoad(this.page);
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    toDel(row) {
      this.disabled = true;
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            this.loading = true;
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.$refs.crud.toggleSelection();
          });
    },
    toEdit(row) {
      this.disabled = true;
      getDetail({id:row.id}).then((res) => {
        this.$refs.crud.rowEdit(res.data);
      })
    },
    beforeOpen(done, type) {
      done();
    },
    beforeClose(done) {
      this.$confirm("确定关闭?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          done();
        })
    },
    rowSave(row, done, loading) {
      if(!row.fileAttach){
        row.fileAttach = [];
      }
      save(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      if(!row.fileAttach){
        row.fileAttach = [];
      }
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    searchReset() {
      this.query.businessName = '';
      this.search.businessName = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page) {
      this.loading = true;
      getPage(Object.assign({ current:page.currentPage, size:page.pageSize}, this.query)).then(res => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.isTableInit = true;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss" scoped>

/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
